/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import LegalLinks from '../../components/legalLinks';
import PageContent from './components/pageContent';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Hippa Privacy Notice Ltc',
          linkUrl: '/hipaa-privacy-notice-ltc/',
          linkAriaLabel: 'Northwestern Mutual Hippa Privacy Notice Ltc',
        },
      ]}
    >

      {/* PAGE CONTENT */}
      <PageContent />

      {/* LEGAL LINKS */}
      <LegalLinks />
    </Page>
  );
};
